import { useParams } from "react-router-dom";

// reusable components
import DiscountPageForm from "./components/DiscountPageForm";

export default function DiscountDetails() {
    const { id } = useParams();
    const isEditMode = id !== "new";

    return (
        <div className="flex flex-col">
            <DiscountPageForm discountId={isEditMode ? id : null} />
        </div>
    );
};